import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import ModalConfirm from '@hellodarwin/core/lib/components/common/hd-modal/confirm';
import copyToClipboard from '@hellodarwin/core/lib/features/helpers/copy-to-clipboard';
import Copy from '@hellodarwin/icons/dist/icons/Copy';
import Delete from '@hellodarwin/icons/dist/icons/Delete';
import RecommendNo from '@hellodarwin/icons/dist/icons/RecommendNo';
import RecommendYes from '@hellodarwin/icons/dist/icons/RecommendYes';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import MessageFeedbackModal from '../message-feedback-modal';
import { MessageActionsContainer, MessageActionsGroup, MessageFeedbackButtons, } from './styles';
export const MessageActions = ({ message, onFeedback, onDelete, showFeedback = true, showDelete = true, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
    const [isSubmittingFeedback, setIsSubmittingFeedback] = useState(false);
    const [currentRating, setCurrentRating] = useState(null);
    const handleRatingClick = async (rating) => {
        if (!onFeedback)
            return;
        setIsSubmittingFeedback(true);
        setCurrentRating(rating);
        try {
            await onFeedback(message.id, message.conversation_id, rating);
            setFeedbackModalOpen(true);
        }
        catch (error) {
            console.error('Failed to submit rating:', error);
        }
        finally {
            setIsSubmittingFeedback(false);
        }
    };
    const handleCommentSubmit = async (comment) => {
        if (!onFeedback || !currentRating)
            return;
        setIsSubmittingFeedback(true);
        try {
            await onFeedback(message.id, message.conversation_id, currentRating, comment);
        }
        catch (error) {
            console.error('Failed to submit comment:', error);
        }
        finally {
            setIsSubmittingFeedback(false);
            setFeedbackModalOpen(false);
        }
    };
    const handleModalClose = () => {
        setFeedbackModalOpen(false);
        setCurrentRating(null);
    };
    const handleDelete = () => {
        onDelete &&
            ModalConfirm({
                title: t('assistant|confirm_delete_message', 'Are you sure you want to delete this message?'),
                content: t('assistant|confirm_delete_message_content', 'This action cannot be undone.'),
                okButtonProps: { defaultStyle: theme.colors.red_1 },
                onOk: async () => await onDelete(message.id),
                onCancel: async () => { },
            });
    };
    const handleCopy = () => {
        if (!message.content)
            return;
        copyToClipboard(message.content);
    };
    const isUserMessage = message.role === 'user';
    const isToolMessage = message.role === 'tool';
    const isTempMessage = message.id.startsWith('tmp_');
    if (isToolMessage) {
        return null;
    }
    return (_jsxs(MessageActionsContainer, { children: [_jsxs(MessageActionsGroup, { children: [showFeedback && !isUserMessage && (_jsxs(MessageFeedbackButtons, { children: [_jsx(Button, { headingIcon: _jsx(RecommendYes, { size: 16 }), transparent: true, size: "circle", defaultStyle: theme.colors.grey_2, onClick: () => handleRatingClick('positive'), disabled: isSubmittingFeedback }), _jsx(Button, { headingIcon: _jsx(RecommendNo, { size: 16 }), transparent: true, size: "circle", defaultStyle: theme.colors.grey_2, onClick: () => handleRatingClick('negative'), disabled: isSubmittingFeedback })] })), !isUserMessage && !isTempMessage && (_jsx(Button, { headingIcon: _jsx(Copy, { size: 16 }), transparent: true, size: "circle", defaultStyle: theme.colors.grey_2, onClick: handleCopy })), showDelete && !isTempMessage && (_jsx(Button, { headingIcon: _jsx(Delete, { size: 16 }), transparent: true, size: "circle", defaultStyle: theme.colors.grey_2, onClick: handleDelete }))] }), _jsx(MessageFeedbackModal, { open: feedbackModalOpen, onClose: handleModalClose, onSubmit: handleCommentSubmit, messageId: message.id, isSubmitting: isSubmittingFeedback, rating: currentRating })] }));
};
export default MessageActions;
